export const Currency = {
    DE: 'EUR',
    PL: 'PLN'
} as const;
